export const tabs = {
	productDetails: {
		label: "Detalles del producto",
		title: "Detalles del producto",
		subtitle: "Información general, precios y stock",
	},
	storages: {
		label: "Almacenes",
		title: "Almacenes",
		subtitle: "Ver todos los almacenes vinculados a este producto",
		table: {
			empty: "Ningún almacén vinculado",
			columns: {
				storage: "Almacén",
			},
		},
	},
	kardex: {
		label: "Ficha Kardex",
		title: "Ficha Kardex",
		subtitle: "La ficha Kardex representa el stock y los movimientos de un ítem.",
	},
	fiscalData: {
		label: "Datos fiscales",
		title: "Datos fiscales",
		subtitle: "Información fiscal del producto",
	},
	technicalSheet: {
		label: "Ficha técnica",
		title: "Ficha técnica",
		subtitle: "Composición e ingredientes del producto",
	},
	bars: {
		label: "Barras",
		title: "Barras",
		subtitle: "Configuración de barras y sectores",
	},
	mountableProduct: {
		label: "Producto montable",
		title: "Producto montable",
		subtitle:
			"Los productos montables permiten que el cliente final haga una combinación a partir de una base fija y una variedad de ingredientes adicionales. En el caso del açaí, por ejemplo, la base sería el açaí batido y los ingredientes adicionales serían paçoca, leche en polvo, etc.",
	},
	qrcode: {
		label: "QR Code",
		title: "QR Code",
	},
};
